module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation-large@2x.dba0186e.png";